import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from './useAuth'
import { useAdmin } from './useAdmin'

export default function AdminRoute() {
  const { state: authState } = useAuth()
  const { state: adminState } = useAdmin()
  const location = useLocation()

  if (authState.status === 'loading') return null
  if (authState.status !== 'authenticated') {
    return <Navigate to="/login" replace state={{ from: location }} />
  }
  if (adminState.status === 'loading') return null
  if (adminState.status !== 'admin') {
    return <Navigate to="/" replace />
  }
  return <Outlet />
}
